import type { i18n as I18n } from 'i18next';

import en from './en.json';

export const CONFIG_NAMESPACE = 'config';

/**
 * Registers the module's own literals under the `config` namespace. The host lists the namespace in
 * `fallbackNS`, so a key such as `config.sections.roles` resolves from here when the host's own
 * bundle does not declare it. The bundle ships with the code, so the namespace is also taken out of
 * the list the backend would otherwise try to load from the server.
 */
export const registerConfigTranslations = (i18n: I18n): void => {
  if (typeof i18n.on !== 'function') return;

  if (!i18n.store) {
    i18n.on('initialized', () => registerConfigTranslations(i18n));
    return;
  }

  if (i18n.hasResourceBundle('en', CONFIG_NAMESPACE)) return;

  i18n.addResourceBundle('en', CONFIG_NAMESPACE, en, true, false);

  const { ns } = i18n.options;
  if (Array.isArray(ns)) i18n.options.ns = ns.filter(name => name !== CONFIG_NAMESPACE);
};
